import { IVirtualManifestBuilderProps } from '@wix/editor-platform-manifest-services';

import { PlatformContext } from '../types';
import { BaseActionPanelAPI } from './BaseActionPanelAPI';
import { isSingleSelection } from '../utils';

import { ReactElement } from 'react';
import { PresetsPanelUIService } from '@wix/editor-platform-feature-store';

export class PresetsActionPanelAPI extends BaseActionPanelAPI {
  constructor(readonly context: PlatformContext) {
    super();
  }

  #getPanelProps() {
    return {
      componentsAPI: this.context.componentsAPI,
      editorPointer: this.context.editorPointers[0],
      editorPointerAPI: this.context.editorPointerAPI,
      biData: { origin: this.context.actionMetadata?.origin ?? '' },
      getSDKHost: async () => {
        const host = await this.getHostContext();
        return host.getHost();
      },
    };
  }

  getContent(): ReactElement | undefined {
    const presetsAPI: PresetsPanelUIService | undefined =
      this.context.editorPlatformPackagesBridge?.PresetsPanelUIServiceAPI;

    if (
      isSingleSelection(this.context.editorPointers) &&
      this.context.hostAPI.editor.hasTemplates?.(this.context.editorPointers[0])
    ) {
      const getTemplates = async () => {
        if (!this.context.hostAPI.editor.getElementTemplates) {
          throw new Error('getElementTemplates is not supported');
        }

        return this.context.hostAPI.editor.getElementTemplates(
          this.context.editorPointers[0],
        );
      };

      return presetsAPI?.getPanelContent({
        getTemplates,
        biData: { origin: this.context.actionMetadata?.origin ?? '' },
      }) as ReactElement;
    }

    const props = this.#getPanelProps();

    return presetsAPI?.getPanelContent(props) as ReactElement;
  }

  async getHostContext(props?: IVirtualManifestBuilderProps) {
    return this.getInfraSDKHostContext({
      ...props,
      editorPointers: props?.editorPointers ?? this.context.editorPointers,
    });
  }
}
